var map = {
	"./01.png": "dd02",
	"./02.png": "d9f5",
	"./03.png": "530b",
	"./04.png": "c5eb",
	"./1.png": "a64b",
	"./2.png": "78c9",
	"./3.png": "3427",
	"./4.png": "7f6c",
	"./5.png": "e212",
	"./arrow.png": "4b82",
	"./close.png": "2338",
	"./cur.png": "e05f",
	"./fenmain.png": "b93f",
	"./icon.png": "13cf",
	"./play.png": "65d8",
	"./video-close.png": "d9d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81c4";